import * as v from "valibot";

export const RSSItemSchema = v.object({
  // title
  title: v.string(),
  // thumbnail url
  thumbnailUrl: v.optional(v.string()),
  // ISO 8601
  date: v.date(),
  // url
  link: v.string(),
});

export type IRSSItem = v.InferOutput<typeof RSSItemSchema>;
